interface OrderableBusinessRule {
  id: number | null;
}

/**
 * Orders a company's business rules to match the oitchau-web (legacy admin) business rules view.
 *
 * oitchau-web renders the rules via `has_many :business_rules, -> { ...order(:id) }`, i.e. ascending
 * by the shared `business_rules` row id. day-core returns that same id on each row but does not apply
 * an `orderBy`, so the raw API order is unspecified and varies between environments. Sorting by id here
 * reproduces oitchau-web's order exactly, for every rule and in any environment.
 *
 * Rows without an id (e.g. a never-persisted rule) sort last, mirroring how oitchau-web appends
 * freshly-built rules at the end of the form.
 *
 * This is the single place the tab's option order is defined. If the desired order ever needs to
 * diverge from oitchau-web, change it here without touching the fetch/save/render logic.
 */
export const sortBusinessRules = <T extends OrderableBusinessRule>(rules: T[]): T[] =>
  [...rules].sort((a, b) => {
    if (a.id == null) return b.id == null ? 0 : 1;
    if (b.id == null) return -1;
    return a.id - b.id;
  });
